import angular from 'angular';
import $ from 'jquery';

export default class UserSpecialPaymentTerms {
  constructor($scope, $rootScope, UserService, UserSpecialPaymentTermService) {
    $scope.set_user_company_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.dialog_term.buyer_id = ui.item.id;
          $scope.dialog_term.buyer_company = ui.item.value;
          $scope.$apply();
        }
      });
    };

    $scope.open_dialog = function(dialog_id) {
      window.openFancyboxDialog('div#' + dialog_id);
    };

    $scope.add_term = function() {
      $scope.dialog_term = angular.copy(window.term);
      $scope.user_company = '';
      $scope.open_dialog('user_term_dialog');
    };

    $scope.edit_term = function(term) {
      $scope.dialog_term = term;
      $scope.user_company = '';
      $scope.open_dialog('user_term_dialog');
    };

    $scope.delete_term = function(index) {
      if (confirm('Are you sure you want to delete this term?')) {
        UserSpecialPaymentTermService.delete($scope.user_terms[index].id).then(function(data) {
          if (data.success) {
            $scope.user_terms.splice(index, 1);
            $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 4 : 6, [{
              type: 'counter',
              value: $scope.user_terms.length
            }]]);
          }
        });
      }
    };

    $scope.save_term = function() {
      $scope.updating_term = true;
      UserSpecialPaymentTermService.save($scope.dialog_term).then(function(data) {
        if (data.success) {
          $scope.updating_term = false;
          $.fancybox.close();
          $scope.user_terms = data.user_terms;
          $rootScope.$broadcast('set_sidebar_data', [window.is_buyer ? 3 : 0, window.is_buyer ? 4 : 6, [{
            type: 'counter',
            value: $scope.user_terms.length
          }]]);
        }
      });
    };

    $scope.init = function() {
      $scope.user_id = window.user_id;
      if (window.role == 1) {
        $scope.currencies = window.currencies;
        $scope.dialog_term = angular.copy(window.term);
      }
      $scope.user_terms = window.user_terms;
      $scope.set_user_company_autocomplete($('input.user_company'));
    };

    $scope.init();

  }
}

UserSpecialPaymentTerms.$inject = ['$scope', '$rootScope', 'UserService', 'UserSpecialPaymentTermService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-special-payment-terms.ctrl.js